import ButtonsContainer from "../general/ButtonsContainer";
import { ExternalLink } from "../ExternalLink";
import { defineMessages, FormattedMessage } from "react-intl";
import React from "react";


const messages = defineMessages( {
	skip: {
		id: "install.skip",
		defaultMessage: "Skip installation and go to MyYoast",
	},
} );

export const SkipInstallationFlowLink = () => {
	return <ButtonsContainer>
		<ExternalLink href={ "/" }><FormattedMessage { ...messages.skip } /></ExternalLink>
	</ButtonsContainer>;
};
